import { render, staticRenderFns } from "./tagComponent.vue?vue&type=template&id=66d12c12"
import script from "./tagComponent.vue?vue&type=script&lang=js"
export * from "./tagComponent.vue?vue&type=script&lang=js"
import style0 from "./tagComponent.vue?vue&type=style&index=0&id=66d12c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports